import React, { useCallback, useRef, useState } from 'react';
import { OverviewCell, PlanRow } from '#@planner/planner/days-overview.jsx';
import { cn } from '#root/lib/helpers/class.js';
import { DetailDiff } from './detail-diff.jsx';
import { checkIfDiffExist } from './helpers.js';
import { group, sameIdOrImportId } from '#@itinerary/places/helpers.js';

export default function PlansDiff(props) {
    const {
        currentPlans,
        updatedPlans,
        documents,
        days,
        deleteDay,
        deletePlan,
        edit,
        incomingPlans,
        incomingDocs,
        places
    } = props;

    // TODO: INSERIRE LOGICA DI MODIFICA PLANS E DAYS IN UN HOOK
    const [selectedDayIndex, setSelectedDayIndex] = useState(0);
    const [selectedPlanId, setSelectedPlanId] = useState(null);

    const selectDay = (dayIndex) => {
        setSelectedDayIndex(dayIndex);
    };
    const total = days?.length;
    const selectedDay = days?.[selectedDayIndex];

    //MANAGE PLANS
    const selectPlan = useCallback(
        (id) => {
            setSelectedPlanId(id);
        },
        [setSelectedPlanId]
    );

    //MANAGE DETAIL
    let Detail;
    if (selectedDay && selectedPlanId !== null) {
        const plan = currentPlans?.find((plan) => sameIdOrImportId(plan, selectedPlanId));
        const updatedPlan = updatedPlans?.find((plan) => sameIdOrImportId(plan, selectedPlanId));
        const dayId = selectedDay.id;
        // Salva la posizione dello scroll attuale
        if (plan)
            // Impedisci lo scroll impostando la posizione dello scroll allo stato precedente
            Detail = (
                <React.Fragment>
                    <DetailDiff
                        dayIndex={selectedDayIndex}
                        onEdit={edit}
                        dayId={dayId}
                        planId={selectedPlanId}
                        itineraryDocuments={documents}
                        incomingPlan={incomingPlans?.find((el) => el?.importId === plan?.importId)}
                        plan={plan}
                        updatedPlan={updatedPlan}
                        incomingDocs={incomingDocs}
                        places={places}
                    />
                </React.Fragment>
            );
    }
    const panelRef = useRef(null);
    const panelHeight = panelRef.current?.clientHeight;

    return (
        // <section className="flex-grow flex flex-col lg:border lg:border-neutral-300 lg:rounded-lg lg:shadow-md p-3">
        <div
            className="flex-grow lg:overflow-hidden overflow-auto lg:border lg:border-neutral-300 lg:rounded-lg lg:shadow-md grid grid-cols-1 lg:grid-cols-12 col-span-full lg:divide-x divide-neutral-200 mb-4"
            ref={panelRef}
        >
            <div
                className="grid col-span-full lg:col-span-6 divide-x divide-neutral-200 lg:overflow-auto p-2 order-2 lg:order-1"
                style={{ height: window.innerHeight > 1024 ? panelHeight : 'auto' }}
            >
                <div className="col-span-full pt-1">
                    {days?.map((day, dayIndex) => {
                        const planIds = day.plans.map((plan) => plan?.id || plan?.importId);
                        return (
                            <OverviewCell
                                {...day}
                                key={day.id}
                                selfId={day.id}
                                hasChild={true}
                                isDeletable={false}
                                dayIndex={dayIndex}
                                selected={selectedDayIndex === dayIndex}
                                onSelect={selectDay}
                            >
                                <ol className="w-full isolate">
                                    {day.plans.map((plan, planIndex) => {
                                        const selected = planIds[planIndex] == selectedPlanId;
                                        const incomingPlan = incomingPlans?.find(
                                            (el) => el?.importId === plan.importId
                                        );
                                        const diffExists = checkIfDiffExist(incomingPlan, plan, 'plan');
                                        const isIncoming =
                                            updatedPlans?.some((el) => sameIdOrImportId(el, plan?.importId)) &&
                                            !currentPlans?.some((el) => sameIdOrImportId(el, plan?.importId));
                                        return (
                                            <PlanRow
                                                key={plan?.id || plan?.importId}
                                                selfId={plan?.id || plan?.importId}
                                                parentId={day.id}
                                                selected={selected}
                                                onSelect={selectPlan}
                                                isDeletable={false}
                                                isIncoming={isIncoming}
                                                diffExists={diffExists}
                                                places={group(places)}
                                                {...plan}
                                            />
                                        );
                                    })}
                                </ol>
                            </OverviewCell>
                        );
                    })}
                </div>
            </div>
            <div
                className={cn(
                    'col-span-full lg:col-span-6 bg-neutral-100 lg:bg-white lg:overflow-auto p-2 order-1 lg:order-2',
                    !Detail && 'hidden lg:block'
                )}
                style={{ height: window.innerHeight > 1024 ? panelHeight : 'auto' }}
            >
                {Detail ? (
                    Detail
                ) : (
                    <section className="hidden lg:block relative h-full">
                        <div className="absolute top-0 left-0 w-full h-full bg-neutral-50 flex justify-center items-center">
                            <p className="w-2/3 text-center text-neutral-400 italic">{_t.edit.planner.detailText()}</p>
                        </div>
                    </section>
                )}
            </div>
        </div>
        // </section>
    );
}
